import {
    ReasonPhrases,
    StatusCodes,
    getReasonPhrase,
    getStatusCode,
} from 'http-status-codes';


const statusCodesDe = {
    [0]: 'Die Anfrage dauerte zu lange oder die Verbindung wurde unterbrochen.',
    [StatusCodes.BAD_REQUEST]: 'Ungültige Anfrage',
    [StatusCodes.REQUEST_TOO_LONG]: 'Anfrage zu groß',
    [900]: '', // custom error: use default message
}

const getMessage = (status: number = 0) => {
    return statusCodesDe[status] !== undefined ? statusCodesDe[status] : getReasonPhrase(status);
}

export type IRequestError = {
    statusCode: number;
    message: string;
    responseData?: any;
};

type IErrorProps = {
    statusCode: number,
    url: string,
    responseData?: any
}

class RequestError {
    public readonly message: string;

    public readonly statusCode: number;
    public readonly responseData: any;

    constructor({ statusCode, url, responseData }: IErrorProps, defaultMessage: string = "Fehler") {
        try {
            // generate user readable message from response
            let message = getMessage(statusCode) || defaultMessage;
            if (responseData && responseData.message) {
                message = responseData.message;
            } else if (responseData && responseData.error) {
                message = responseData.error;
            } else if (responseData && responseData.errors && responseData.errors.length) {
                message = responseData.errors.join(', ');
            }

            this.message = message;
            this.statusCode = statusCode;
            this.responseData = responseData;
        } catch (e) {
            console.error(e);
            this.message = defaultMessage;
            this.statusCode = statusCode;
            this.responseData = responseData;
        }
    }
}


export default RequestError;